import createAxios from '/@/utils/axios'
import { isAdminApp, checkFileMimetype } from '/@/utils/common'
import * as createAxiosNode from '/@/utils/axiosNode'
import { getUrl } from '/@/utils/axios'
import { useAdminInfo } from '/@/stores/adminInfo'
import { useUserInfo } from '/@/stores/userInfo'
import { ElNotification, type UploadRawFile } from 'element-plus'
import { useSiteConfig } from '/@/stores/siteConfig'
import { state as uploadExpandState, fileUpload as uploadExpand } from '/@/components/mixins/baUpload'
import type { AxiosRequestConfig } from 'axios'
import { uuid } from '/@/utils/random'
import { i18n } from '../lang'
import { adminBaseRoutePath } from '/@/router/static/adminBase'

/*
 * 公共请求函数和Url定义
 */

// Admin模块
export const adminUploadUrl = '/admin/ajax/upload'
export const adminBuildSuffixSvgUrl = adminBaseRoutePath + '/ajax/buildSuffixSvg'
export const adminAreaUrl = '/admin/ajax/area'
export const getTablePkUrl = '/admin/ajax/getTablePk'
export const getTableListUrl = '/admin/ajax/getTableList'
export const getTableFieldListUrl = '/admin/ajax/getTableFieldList'
export const getDatabaseConnectionListUrl = '/admin/ajax/getDatabaseConnectionList'
export const terminalUrl = adminBaseRoutePath + '/ajax/terminal'
export const changeTerminalConfigUrl = '/admin/ajax/changeTerminalConfig'
export const clearCacheUrl = '/admin/ajax/clearCache'

// 公共
export const captchaUrl = '/api/common/captcha'
export const clickCaptchaUrl = '/api/common/clickCaptcha'
export const checkClickCaptchaUrl = '/api/common/checkClickCaptcha'
export const refreshTokenUrl = '/api/common/refreshToken'

// api模块(前台)
export const apiUploadUrl = '/api/ajax/upload'
export const apiBuildSuffixSvgUrl = '/api/ajax/buildSuffixSvg'
export const apiAreaUrl = '/api/ajax/area'
export const apiSendSms = '/api/Sms/send'
export const apiSendEms = '/api/Ems/send'
export const apiAdminPoints = '/api/Review'

export const apiList   = '/api/Engineering'


//添加图例库详情
export function addLibraryImage(params: object = {}) {
  return createAxios({
    url: apiList + '/addLibraryImage',
    data: params,
    method: 'post',
  })
}

//更新图例库详情
export function updateLibraryInfo(params: object = {}) {
  return createAxios({
    url: apiList + '/updateLibraryInfo',
    data: params,
    method: 'post',
  })
}

//删除图例库详情
export function deleteLibraryInfo(params: object = {}) {
  return createAxios({
    url: apiList + '/deleteLibraryInfo',
    data: params,
    method: 'post',
  })
}

//查询图例库详情
export function selectLibraryInfo(params: object = {}) {
  return createAxios({
    url: apiList + '/selectLibraryInfo',
    data: params,
    method: 'post',
  })
}

//添加图例库
export function addLibraryRecord(params: object = {}) {
  return createAxios({
    url: apiList + '/addLibraryRecord',
    data: params,
    method: 'post',
  })
}

//编辑图例库
export function updateLibrary(params: object = {}) {
  return createAxios({
    url: apiList + '/updateLibrary',
    data: params,
    method: 'post',
  })
}

//查询图例库记录列表
export function selectLibraryRecord(params: object = {}) {
  return createAxios({
    url: apiList + '/selectLibraryRecord',
    data: params,
    method: 'post',
  })
}

//删除图例库记录
export function deleteLibraryRecord(params: object = {}) {
  return createAxios({
    url: apiList + '/deleteLibraryRecord',
    data: params,
    method: 'post',
  })
}


//查询类别列表
export function selectType() {
  return createAxios({
    url: apiList + '/selectType',
    method: 'get',
  })
}

//更新所有要点
export function updateAllPoints(params: object = {}) {
    return createAxios({
        url: apiAdminPoints + '/updateAllPoints',
        data: params,
        method: 'post',
    })
}

//添加所有要点
export function addAllPoints(params: object = {}) {
    return createAxios({
        url: apiAdminPoints + '/addAllPoints',
        data: params,
        method: 'post',
    })
}

//获取所有要点
export function getNormsPointsList(params: object = {}) {
    return createAxios({
        url: apiAdminPoints + '/getNormsPointsList',
        data: params,
        method: 'post',
    })
}

//获取要点
export function getPointsList(params: object = {}) {
    return createAxios({
        url: apiAdminPoints + '/getPointsList',
        data: params,
        method: 'post',
    })
}

//更新专项
export function updatePlan(params: object = {}) {
    return createAxios({
        url: apiAdminPoints + '/updatePlan',
        data: params,
        method: 'post',
    })
}

//添加专项
export function addPlan(params: object = {}) {
    return createAxios({
        url: apiAdminPoints + '/addPlan',
        data: params,
        method: 'post',
    })
}

//查询专项
export function getPlanList(params: object = {}) {
    return createAxios({
        url: apiAdminPoints + '/getPlanList',
        data: params,
        method: 'post',
    })
}

//更新文件
export function updateFileInfo(params: object = {}) {
    return createAxios({
        url: apiAdminPoints + '/updateFileInfo',
        data: params,
        method: 'post',
    })
}
//添加审查要点
export function addListPoints(params: object = {}) {
    return createAxios({
        url: apiAdminPoints + '/addListPoints',
        data: params,
        method: 'post',
    })
}

//更新审查要点
export function updateListPoints(params: object = {}) {
    return createAxios({
        url: apiAdminPoints + '/updateListPoints',
        data: params,
        method: 'post',
    })
}



//删除
export function deletePoints(params: object = {}) {
    return createAxios({
        url: apiAdminPoints + '/deletePoints',
        data: params,
        method: 'post',
    })
}

//查询列表
export function checkPoints(params: object = {}) {
    return createAxios({
        url: apiAdminPoints + '/checkPoints',
        data: params,
        method: 'post',
    })
}

//查询列表
export function selectPoints(params: object = {}) {
    return createAxios({
        url: apiAdminPoints + '/selectPoints',
        data: params,
        method: 'post',
    })
}

//添加要点
export function addPoints(params: object = {}) {
    return createAxios({
        url: apiAdminPoints + '/adminPoints',
        data: params,
        method: 'post',
    })
}
/**
 * 上传文件
 */
export async function fileUpload(fd: FormData, params: anyObj = {}, forceLocal = false, config: AxiosRequestConfig = {}): ApiPromise {
    let errorMsg = ''
    const file = fd.get('file') as UploadRawFile
    const siteConfig = useSiteConfig()

    if (!file.name || typeof file.size == 'undefined') {
        errorMsg = i18n.global.t('utils.The data of the uploaded file is incomplete!')
    } else if (!checkFileMimetype(file.name, file.type)) {
        errorMsg = i18n.global.t('utils.The type of uploaded file is not allowed!')
    } else if (file.size > siteConfig.upload.maxSize) {
        errorMsg = i18n.global.t('utils.The size of the uploaded file exceeds the allowed range!')
    }
    if (errorMsg) {
        return new Promise((resolve, reject) => {
            ElNotification({
                type: 'error',
                message: errorMsg,
                zIndex: 9999,
            })
            reject(errorMsg)
        })
    }

    if (!forceLocal && uploadExpandState() == 'enable') {
        return uploadExpand(fd, params, config)
    }
    // 添加唯一时间戳防止请求被认为是重复的
    const uniqueParams = {
        ...params,
        _uploadTimestamp: Date.now(),
        _uploadRandom: Math.random()
    }
    fd.append('driver', 'alioss') // 强制使用阿里云OSS上传
    const res = await createAxios({
        url: isAdminApp() ? adminUploadUrl : apiUploadUrl,
        method: 'POST',
        data: fd,
        params: uniqueParams,
        timeout: 0,
        ...config,
    })
    res.data.file.url = res.data.file.full_url || res.data.file.url
    console.log('res', res);
    return res
}

/**
 * 生成文件后缀icon的svg图片
 * @param suffix 后缀名
 * @param background 背景色,如:rgb(255,255,255)
 */
export function buildSuffixSvgUrl(suffix: string, background = '') {
    const adminInfo = useAdminInfo()
    return (
        getUrl() +
        (isAdminApp() ? adminBuildSuffixSvgUrl : apiBuildSuffixSvgUrl) +
        '?batoken=' +
        adminInfo.getToken() +
        '&suffix=' +
        suffix +
        (background ? '&background=' + background : '') +
        '&server=1'
    )
}

/**
 * 获取地区数据
 */
export function getArea(values: number[]) {
    const params: { province?: number; city?: number; uuid?: string } = {}
    if (values[0]) {
        params.province = values[0]
    }
    if (values[1]) {
        params.city = values[1]
    }
    params.uuid = uuid()
    return createAxios({
        url: isAdminApp() ? adminAreaUrl : apiAreaUrl,
        method: 'GET',
        params: params,
    })
}

/**
 * 发送短信
 */
export function sendSms(mobile: string, templateCode: string, extend: anyObj = {}, type: undefined | string = undefined) {
    return createAxios(
        {
            url: apiSendSms,
            method: 'POST',
            data: {
                mobile: mobile,
                template_code: templateCode,
                ...extend,
                type
            },
        },
        {
            showSuccessMessage: true,
        }
    )
}

/**
 * 发送邮件
 */
export function sendEms(email: string, event: string, extend: anyObj = {}) {
    return createAxios(
        {
            url: apiSendEms,
            method: 'POST',
            data: {
                email: email,
                event: event,
                ...extend,
            },
        },
        {
            showSuccessMessage: true,
        }
    )
}

/**
 * 缓存清理接口
 */
export function postClearCache(type: string) {
    return createAxios(
        {
            url: clearCacheUrl,
            method: 'POST',
            data: {
                type: type,
            },
        },
        {
            showSuccessMessage: true,
        }
    )
}

/**
 * 构建命令执行窗口url
 */
export function buildTerminalUrl(commandKey: string, uuid: string, extend: string) {
    const adminInfo = useAdminInfo()
    return (
        getUrl() + terminalUrl + '?command=' + commandKey + '&uuid=' + uuid + '&extend=' + extend + '&batoken=' + adminInfo.getToken() + '&server=1'
    )
}

/**
 * 请求修改终端配置
 */
export function postChangeTerminalConfig(data: { manager?: string; port?: string }) {
    return createAxios({
        url: changeTerminalConfigUrl,
        method: 'POST',
        data: data,
    })
}

/**
 * 远程下拉框数据获取
 */
export function getSelectData(remoteUrl: string, q: string, params: {}, isNode: boolean = false) {
    return isNode ? createAxiosNode.default({
        url: remoteUrl,
        method: 'get',
        params: Object.assign(params, {
            select: true,
            quickSearch: q,
        }),
    }) : createAxios({
        url: remoteUrl,
        method: 'get',
        params: Object.assign(params, {
            select: true,
            quickSearch: q,
        }),
    })
}
export function buildCaptchaUrl() {
    return getUrl() + captchaUrl + '?server=1'
}

export function getCaptchaData(id: string) {
    return createAxios({
        url: clickCaptchaUrl,
        method: 'get',
        params: {
            id,
        },
    })
}

export function checkClickCaptcha(id: string, info: string, unset: boolean) {
    return createAxios(
        {
            url: checkClickCaptchaUrl,
            method: 'post',
            data: {
                id,
                info,
                unset,
            },
        },
        {
            showCodeMessage: false,
        }
    )
}

export function getTablePk(table: string, connection = '') {
    return createAxios({
        url: getTablePkUrl,
        method: 'get',
        params: {
            table: table,
            connection: connection,
        },
    })
}

/**
 * 获取数据表的字段
 * @param table 数据表名
 * @param clean 只要干净的字段注释（只要字段标题）
 */
export function getTableFieldList(table: string, clean = true, connection = '') {
    return createAxios({
        url: getTableFieldListUrl,
        method: 'get',
        params: {
            table: table,
            clean: clean ? 1 : 0,
            connection: connection,
        },
    })
}

export function refreshToken() {
    const adminInfo = useAdminInfo()
    const userInfo = useUserInfo()
    return createAxios({
        url: refreshTokenUrl,
        method: 'POST',
        data: {
            refreshToken: isAdminApp() ? adminInfo.getToken('refresh') : userInfo.getToken('refresh'),
        },
    })
}

/**
 * 生成一个控制器的：增、删、改、查、排序的操作url
 */
export class baTableApi {
    private controllerUrl
    public actionUrl
    public isNode: boolean

    constructor(controllerUrl: string, isNode: boolean = false) {
        this.controllerUrl = controllerUrl
        this.isNode = isNode
        this.actionUrl = new Map([
            ['index', controllerUrl + 'index'],
            ['add', controllerUrl + 'add'],
            ['edit', controllerUrl + 'edit'],
            ['del', controllerUrl + 'del'],
            ['sortable', controllerUrl + 'sortable'],
        ])
    }

    index(filter: anyObj = {}) {

        return this.isNode ? createAxiosNode.default<TableDefaultData>({
            url: this.actionUrl.get('index'),
            method: 'get',
            params: filter,
        }) : createAxios<TableDefaultData>({
            url: this.actionUrl.get('index'),
            method: 'get',
            params: filter,
        })
    }

    edit(params: anyObj) {
        return this.isNode ? createAxiosNode.default({
            url: this.actionUrl.get('edit'),
            method: 'get',
            params: params,
        }) : createAxios({
            url: this.actionUrl.get('edit'),
            method: 'get',
            params: params,
        })
    }

    del(ids: string[]) {
        return this.isNode ? createAxiosNode.default(
            {
                url: this.actionUrl.get('del'),
                method: 'DELETE',
                params: {
                    ids: ids,
                },
            },
            {
                showSuccessMessage: true,
            }
        ) : createAxios(
            {
                url: this.actionUrl.get('del'),
                method: 'DELETE',
                params: {
                    ids: ids,
                },
            },
            {
                showSuccessMessage: true,
            }
        )
    }

    postData(action: string, data: anyObj) {
        return this.isNode ? createAxiosNode.default(
            {
                url: this.actionUrl.has(action) ? this.actionUrl.get(action) : this.controllerUrl + action,
                method: 'post',
                data: data,
            },
            {
                showSuccessMessage: true,
            }
        ) : createAxios(
            {
                url: this.actionUrl.has(action) ? this.actionUrl.get(action) : this.controllerUrl + action,
                method: 'post',
                data: data,
            },
            {
                showSuccessMessage: true,
            }
        )
    }

    sortableApi(id: number, targetId: number) {
        return this.isNode ? createAxiosNode.default({
            url: this.actionUrl.get('sortable'),
            method: 'post',
            data: {
                id: id,
                targetId: targetId,
            },
        }) : createAxios({
            url: this.actionUrl.get('sortable'),
            method: 'post',
            data: {
                id: id,
                targetId: targetId,
            },
        })
    }
}
